<label class="form-label" for="datospersona_nombre" (click)="onClicked()">
    <ng-content></ng-content>
</label>
